export default "__VITE_ASSET__e4ba3415__"